var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-scheme-card-new",class:{
    'color-scheme-card-new--selected': _vm.isSelected
  },style:(_vm.previewStyle),attrs:{"role":"button"},on:{"mouseenter":_vm.select}},[(_vm.isSelected)?_c('div',{staticClass:"color-scheme-card__dot"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }